var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowEditModal',{ref:"modal",attrs:{"read-only":_vm.readOnly,"database":_vm.database,"table":_vm.table,"rows":[],"all-fields-in-table":_vm.fields,"visible-fields":_vm.fields,"fields-sortable":_vm.fieldsSortable,"can-modify-fields":_vm.canModifyFields},on:{"hidden":function($event){return _vm.$emit('hidden', $event)},"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }